export const messages = {
    RESET_YOUR_PASSWORD: 'A email has been sent to your registered email id. Please check your inbox to reset your password.',
    VERIFY_YOUR_ACCOUNT: 'A verification email has been sent to your email id ',
    KINDLY_VERIFY: ', kindly verify.'
}